import AdditionalInfo from './AdditionalInfo.vue'

export default AdditionalInfo
